import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-header-alt',
  templateUrl: './header-alt.component.html',
  styleUrl: './header-alt.component.scss'
})
export class HeaderAltComponent {
  @Input() title: string | undefined;
  @Input() isBold: boolean = false;
  @Input() isSemiBold: boolean = false;
}
